import { render, staticRenderFns } from "./5LineageSelection.vue?vue&type=template&id=274fe09f&scoped=true&"
import script from "./5LineageSelection.vue?vue&type=script&lang=js&"
export * from "./5LineageSelection.vue?vue&type=script&lang=js&"
import style0 from "./5LineageSelection.vue?vue&type=style&index=0&id=274fe09f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274fe09f",
  null
  
)

export default component.exports